import type { CSSProperties } from 'react';
import Image from 'next/image';
import styles from './assistant-avatar.module.css';

export interface AssistantAvatarProps {
  size?: number;
  className?: string;
}

/** The circle frames the portrait; the hair deliberately extends above it. */
export function AssistantAvatar({ size = 80, className }: AssistantAvatarProps) {
  const diameter = Math.max(24, Math.min(240, Number.isFinite(size) ? size : 80));
  return (
    <span
      className={[styles.avatar, className].filter(Boolean).join(' ')}
      style={{ '--assistant-avatar-size': `${diameter}px` } as CSSProperties}
      aria-hidden="true"
      data-assistant-avatar="true"
      data-avatar-circle="true"
    >
      <span className={styles.portrait} data-avatar-portrait="true">
        <Image
          src="/storefront/assistant-avatar-v1.webp"
          alt=""
          width={280}
          height={280}
          sizes={`${Math.ceil(diameter * 1.16)}px`}
          draggable={false}
          data-avatar-image="true"
        />
      </span>
    </span>
  );
}
